import React from 'react';
import NumberFormat from 'react-number-format';
import { Table } from 'semantic-ui-react';

type OrderItemsProps = {
  items: any[]
  colSpan?: number
};

function OrderItemsComponent({ items, colSpan = 9 }: OrderItemsProps) {

  return (<React.Fragment>
    {items?.map((order: any, index: number) => {
      return <Table.Row key={`order-${order.id}-${index}`}>
        <Table.Cell colSpan={colSpan} data-label="Бараа">
          <div className="flex-only align-center">
            <strong>{order.product.name}</strong>
            <span>
              &nbsp;
              <NumberFormat displayType="text" value={order.price} suffix="₮" thousandSeparator={true} /> x {order.count}
              &nbsp;=&nbsp;
              <NumberFormat displayType="text" value={order.price * order.count} suffix="₮" thousandSeparator={true} />
              {order.deliveryCost > 0 && (
                <span style={{ color: 'var(--admin-text-muted)', fontSize: '0.9em' }}>
                  &nbsp;(Хүргэлт: <NumberFormat displayType="text" value={order.deliveryCost} suffix="₮" thousandSeparator={true} />)
                </span>
              )}
            </span>
          </div>
        </Table.Cell>
      </Table.Row>
    })}
  </React.Fragment>
  );
}

export default OrderItemsComponent;
